import { Component, Input, OnChanges } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { shouldShowStockLimitInfo } from '../../helpers/product-quantity-info.helper';

@Component({
  standalone: false,
  selector: 'product-quantity-info',
  template: `<span [ngClass]="cssClass">{{ message }}</span>`
})
export class ProductQuantityInfoComponent implements OnChanges {
  @Input() min: number;
  @Input() max: number;
  @Input() stockLeft: number;
  @Input() dailyLimit: number;
  @Input() unitKey: string;
  @Input() cssClass = '';

  public message = '';

  constructor(private _translate: TranslateService) {
  }

  ngOnChanges() {
    this.message = this._getMessage();
  }

  private _getMessage() {
    const isMinExist = this.min && this.min > 1;

    const unit = this._translate.instant(
      `cakeBuilder.sizeUnits.unitTypePlural.${this.unitKey}`,
    );

    if (shouldShowStockLimitInfo(this.stockLeft, this.max)) {
      return this._translate.instant(
        'cakeBuilder.stockQuantityNotice',
        { count: this.stockLeft },
      );
    } else if (shouldShowStockLimitInfo(this.dailyLimit, this.max)) {
      return this._translate.instant(
        'cakeBuilder.dailyLimitQuantityNotice',
        { dailyLimit: this.dailyLimit },
      );
    } else if (isMinExist && this.max) {
      return this._translate.instant(
        'cakeBuilder.minMaxQuantityNotice',
        { min: this.min, max: this.max, unitKey: unit, },
      );
    } else if (isMinExist) {
      return this._translate.instant(
        'cakeBuilder.minQuantityNotice',
        { min: this.min, unitKey: unit, },
      );
    } else if (this.max) {
      return this._translate.instant(
        'cakeBuilder.maxQuantityNotice',
        { max: this.max, unitKey: unit, },
      );
    }
  }
}
